<template>
    <Header />
    <RouterView />
    <Footer />
</template>

<script setup>

import Header from '@/layout/Header.vue'
import Footer from '@/layout/Footer.vue'
import { RouterView } from 'vue-router';
import { onBeforeMount } from 'vue';
import { useI18n } from 'vue-i18n';
const { locale } = useI18n()

onBeforeMount(() => {
  if(window.localStorage.getItem('language')) {
    locale.value = window.localStorage.getItem('language');
    return;
  }

  const userLanguage = navigator.language;
  if(['pl', 'cs', 'sk'].includes(userLanguage)) {
    localStorage.setItem('language', userLanguage);
    locale.value = userLanguage;
  } else {
    localStorage.setItem('language', 'en');
    locale.value = 'en'
  }
})

</script>

<style lang="scss">
@import '@/assets/styles/main.scss';
</style>
